import type { IconSvgObject } from './types';

const AlignEndHorizontalIcon: IconSvgObject = [
  ["path", { d: "M5 15L5 5C5 3.89543 5.89543 3 7 3L8 3C9.10457 3 10 3.89543 10 5L10 15C10 16.1046 9.10457 17 8 17H7C5.89543 17 5 16.1046 5 15Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 15L14 11C14 9.89543 14.8954 9 16 9L17 9C18.1046 9 19 9.89543 19 11V15C19 16.1046 18.1046 17 17 17H16C14.8954 17 14 16.1046 14 15Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 21H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default AlignEndHorizontalIcon;
